import {
    SET_ORDER, SET_ENABLEORDERTRACKING, SET_ENABLEDROPSHIPFLAG, SET_SHOWRETURNABLE, SET_ENABLEPARTORDERING
} from './types';
 
const setSelectedOrder = (selectedOrder:any) => ({
    type: SET_ORDER,
    selectedOrder
})

const setEnableOrderTracking = (enableOrderTracking: any) => ({
    type: SET_ENABLEORDERTRACKING,
    enableOrderTracking
})

const setEnableDropshipFlag = (enableDropshipFlag: any) => ({
    type: SET_ENABLEDROPSHIPFLAG,
    enableDropshipFlag
})

const setReturnableFlag = (showReturnableFlag: any) => ({
    type: SET_SHOWRETURNABLE,
    showReturnableFlag
})

const setEnablePartOrdering = (enablePartOrdering: any) => ({
    type: SET_ENABLEPARTORDERING,
    enablePartOrdering
})

export {
    setSelectedOrder, setEnableOrderTracking, setEnableDropshipFlag, setReturnableFlag, setEnablePartOrdering
};
  